import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
//import router from '@/router'
import vuecookie from 'vue-cookies'

const state = {
  sendExceptionColumnsForImport: [],
  sendExceptionAttributes: [],
  sendExceptionRulesColumns: [],
  sendExceptionRulesSearchFilters: [],
  sendExceptionInstructions: [],

  docTypes: [],
  batchTypes: [],
  entities: [],
  brands: [],

  rules: [],
  ruleData: [],
  sendExceptions: [],
  sendExceptionsExampleCSV: ''
};

const getters = {
  getExceptionsColumnsForImport: (state) => state.sendExceptionColumnsForImport,
  getSendExceptionRulesAttributes: (state) => state.sendExceptionAttributes,
  getSendExceptionRulesColumns: (state) => state.sendExceptionRulesColumns,
  getSendExceptionRulesSearchFilters: (state) => state.sendExceptionRulesSearchFilters,
  getSendExceptionInstructions: (state) => state.sendExceptionInstructions,

  getDocTypes: (state) => state.docTypes,
  getBatchTypes: (state) => state.batchTypes,
  getEntities: (state) => state.entities,
  getBrands: (state) => state.brands,

  getRules: (state) => state.rules,
  getRuleData: (state) => state.ruleData,
  getSendExceptions: (state) => state.sendExceptions,
  getSendExceptionsExampleCSV: (state) => state.sendExceptionsExampleCSV
};

const actions = {
  async destroySendExceptionsCSV( context, data ) {
      await axios.post(`${backendUrl()}/destroySendExceptionsCSV`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response, {root: true})
      })
  },
  async getExceptionsColumnsForImport(context) {
      await axios.get(`${backendUrl()}/getExceptionsColumnsForImport`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setSendExceptionColumnsForImport', response.data)
      })
  },
  async getSendExceptionRulesAttributes(context) {
      await axios.get(`${backendUrl()}/getSendExceptionRulesAttributes`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setSendExceptionRulesAttributes', response.data)
      })
  },
  async getSendExceptionRulesColumns(context) {
      await axios.get(`${backendUrl()}/getSendExceptionRulesColumns`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setSendExceptionRulesColumns', response.data)
      })
  },
  async getSendExceptionRulesSearchFilters(context) {
      await axios.get(`${backendUrl()}/getSendExceptionRulesSearchFilters`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setSendExceptionRulesSearchFilters', response.data.rules)
          context.commit('setSendExceptionInstructions', response.data.instructions)
      })
  },

  async getDocumentTypes(context) {
      await axios.get(`${backendUrl()}/getDocumentTypesForSendExceptions`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setDocTypes', response.data)
      })
  },
  async getBatchTypes(context) {
      await axios.get(`${backendUrl()}/getBatchTypesForSendExceptions`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setBatchTypes', response.data)
      })
  },
  async getEntities(context) {
      await axios.get(`${backendUrl()}/getEntities`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setEntities', response.data)
      })
  },
  async getBrands(context) {
      await axios.get(`${backendUrl()}/getBrands`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setBrands', response.data)
      })
  },

  async getRules(context) {
      await axios.get(`${backendUrl()}/getRules`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setRules', response.data)
      })
  },
  async getRuleData( context, data ) {
      return await axios.post(`${backendUrl()}/getRuleData`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setRuleData', response.data)
          return response.data
      })
  },
  async getSendExceptions( context, data ) {
      await axios.post(`${backendUrl()}/getSendExceptions`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setSendExceptions', response.data)
      })
  },
  async addNewSendException( context, data ) {
      await axios.post(`${backendUrl()}/addNewSendException`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response, {root: true})
      })
  },
  async importSendExceptions( context, data ) {
      return await axios.post(`${backendUrl()}/importSendExceptions`, data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': "bearer " +  vuecookie.get('token')
          }
        }).then(response => {
          context.dispatch('handleResponse', response, {root: true})
          return response.data
        })
  },
  async editSendException( context, data ) {
      await axios.post(`${backendUrl()}/editSendException`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response, {root: true})
      })
  },
  async deleteSendException( context, data ) {
      await axios.post(`${backendUrl()}/deleteSendException`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response, {root: true})
      })
  },
  async enableSendException( context, data ) {
      await axios.post(`${backendUrl()}/enableSendException`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response, {root: true})
      })
  },
  async disableSendException( context, data ) {
      await axios.post(`${backendUrl()}/disableSendException`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response, {root: true})
      })
  },
  async getSendExceptionsExampleCSV(context) {
      await axios.get(`${backendUrl()}/getSendExceptionsExampleCSV`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setSendExceptionsExampleCSV', response.data)
      })
  },

  async getExceptionRuleValues( context, data ) {
    return await axios.post(`${backendUrl()}/getExceptionRuleValues`,
    {
        ruleValues: data
    },
    {
        headers: { 'Authorization': "bearer " + vuecookie.get('token') }
    }).then(response => {
        return response.data
    })
  }
};

const mutations = {
  setSendExceptionColumnsForImport: (state, sendExceptionColumnsForImport) => (state.sendExceptionColumnsForImport = sendExceptionColumnsForImport),
  setSendExceptionRulesAttributes: (state, sendExceptionAttributes) => (state.sendExceptionAttributes = sendExceptionAttributes),
  setSendExceptionRulesColumns: (state, sendExceptionRulesColumns) => (state.sendExceptionRulesColumns = sendExceptionRulesColumns),
  setSendExceptionRulesSearchFilters: (state, sendExceptionRulesSearchFilters) => (state.sendExceptionRulesSearchFilters = sendExceptionRulesSearchFilters),
  setSendExceptionInstructions: (state, instructions) => (state.sendExceptionInstructions = instructions),

  setDocTypes: (state, docTypes) => (state.docTypes = docTypes),
  setBatchTypes: (state, batchTypes) => (state.batchTypes = batchTypes),
  setEntities: (state, entities) => (state.entities = entities),
  setBrands: (state, brands) => (state.brands = brands),

  setRules: (state, rules) => (state.rules = rules),
  setRuleData: (state, ruleData) => (state.ruleData = ruleData),
  setSendExceptions: (state, sendExceptions) => (state.sendExceptions = sendExceptions),
  setSendExceptionsExampleCSV: (state, sendExceptionsExampleCSV) => (state.sendExceptionsExampleCSV = sendExceptionsExampleCSV)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
